import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import 'flowbite';
import '@/Public/Scss/main.scss';
import SimpleParallax from "simple-parallax-js/vanilla";
import './cookieConsent';

document.addEventListener('DOMContentLoaded', () => {
    new SimpleParallax(document.querySelectorAll('.simple-parallax'), {
        scale: 1.2
    });

    new SimpleParallax(document.querySelectorAll('.simple-parallax-stage'), {
        scale: 1.1,
    });
});

const prevSlideMessage = 'Vorheriger Inhalt'
const nextSlideMessage = 'Nächster Inhalt'
const firstSlideMessage = 'Das ist der erste Inhalt'
const lastSlideMessage = 'Das ist der letzte Inhalt'
const paginationBulletMessage = 'Gehe zu Inhalt {{index}}'

if (document.querySelector('.swiper-slide-col-1')) {
    const Swiper1Col = function () {
        const customSwiper = document.querySelectorAll('.swiper-slide-col-1')
        let i: number
        for (i = 0; i < customSwiper.length; i++) {
            customSwiper[i].classList.add('swiper-slide-col-1-' + i)

            const swiperSlideCol01 = new Swiper('.swiper-slide-col-1-' + i, {
                loop: true,
                slidesPerView: 1,
                slidesPerGroup: 1,
                spaceBetween: 0,
                watchOverflow: true,
                speed: 1000,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                    bulletElement: 'li',
                    dynamicBullets: false,
                    renderBullet: function (index: number, className: string) {
                        return '<li class="' + className + '"><span class="hidden">' + (index + 1) + '</span></li>';
                    }
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                keyboard: {
                    enabled: true
                },
                a11y: {
                    prevSlideMessage,
                    nextSlideMessage,
                    firstSlideMessage,
                    lastSlideMessage,
                    paginationBulletMessage,
                    slideLabelMessage: '',
                    slideRole: 'listitem'
                },
                on: {
                    afterInit: function () {
                        const swiperRole = document.querySelectorAll('.swiper-slide')
                        swiperRole.forEach(function (element) {
                            element.removeAttribute('role')
                        });

                        const button = document.querySelectorAll(`.swiper-slide-col-1-${i} .btn`);
                        button.forEach(function (item) {
                            item.addEventListener('keydown', function (event: Event) {
                                const keyEvent = event as KeyboardEvent;
                                if (keyEvent.keyCode === 9) {
                                    event.preventDefault();
                                    const activeBullet = document.querySelector('.swiper-pagination-bullet-active') as HTMLElement;
                                    if (activeBullet) {
                                        activeBullet.focus();
                                    }
                                }
                            });
                        });

                        // Space key to click pagination bullet and focus on stage-subheader when clicked
                        const pagination = document.querySelectorAll(`.swiper-slide-col-1-${i} .swiper-pagination-bullet`);
                        pagination.forEach(function (item, index) {
                            item.addEventListener('keydown', function (event: Event) {
                                const keyEvent = event as KeyboardEvent;
                                if (keyEvent.keyCode === 32) {
                                    event.preventDefault();
                                    (item as HTMLElement).click();
                                }
                            });
                            item.addEventListener('click', function() {
                                const subHeaderElement = swiperSlideCol01.slides[index].querySelector('.stage-subheader') as HTMLElement;
                                if (subHeaderElement) {
                                    subHeaderElement.focus();
                                }
                            });
                        });
                    }
                }
            })
        }
    }

    Swiper1Col();
}

document.addEventListener("DOMContentLoaded", function () {
    const swiper = new Swiper(".room-gallery-thumbs", {
        loop: false,
        spaceBetween: 10,
        slidesPerView: 3,
        freeMode: true,
        watchSlidesProgress: true,
        breakpoints: {
            480: {
                slidesPerView: 4,
            },
            1024: {
                slidesPerView: 5,
                spaceBetween: 12,
            }
        }
    });
    const swiper2 = new Swiper(".room-gallery", {
        loop: false,
        spaceBetween: 12,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        keyboard: {
            enabled: true,
        },
        thumbs: {
            swiper: swiper,
        },
    });

    // Fullscreen overlay toggle for the room gallery (CSS overlay, not native Fullscreen API)
    const galleryWrapper = document.querySelector<HTMLElement>(".room-gallery-wrapper");
    const gallery = document.querySelector<HTMLElement>(".room-gallery");
    const fullscreenBtn = document.querySelector<HTMLButtonElement>(".room-gallery-fullscreen");
    if (galleryWrapper && gallery && fullscreenBtn) {
        const iconEnter = fullscreenBtn.querySelector<SVGElement>(".icon-enter");
        const iconExit = fullscreenBtn.querySelector<SVGElement>(".icon-exit");

        const setIconState = (isFull: boolean): void => {
            iconEnter?.classList.toggle("hidden", isFull);
            iconExit?.classList.toggle("hidden", !isFull);
            fullscreenBtn.setAttribute(
                "aria-label",
                isFull ? "Vollbildansicht schließen" : "Vollbildansicht öffnen"
            );
        };

        // Re-measure both swipers after the overlay toggles. Preserve active
        // slide explicitly so changes to slidesPerView (breakpoints) on the
        // thumb strip don't visually shift the starting position.
        const refreshSwipers = (): void => {
            const targetIndex = swiper2.activeIndex;
            swiper2.update();
            swiper.update();
            swiper2.slideTo(targetIndex, 0, false);
        };

        const openOverlay = (): void => {
            galleryWrapper.classList.add("is-fullscreen");
            document.body.classList.add("overflow-hidden");
            setIconState(true);
            requestAnimationFrame(refreshSwipers);
        };

        const closeOverlay = (): void => {
            galleryWrapper.classList.remove("is-fullscreen");
            document.body.classList.remove("overflow-hidden");
            setIconState(false);
            requestAnimationFrame(refreshSwipers);
        };

        fullscreenBtn.addEventListener("click", (e) => {
            e.preventDefault();
            if (galleryWrapper.classList.contains("is-fullscreen")) {
                closeOverlay();
            } else {
                openOverlay();
            }
        });

        document.addEventListener("keydown", (e) => {
            if (e.key === "Escape" && galleryWrapper.classList.contains("is-fullscreen")) {
                closeOverlay();
            }
        });
    }

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    new Swiper(".testimonial__slider", {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        speed: reduceMotion ? 0 : 1000,
        autoplay: reduceMotion ? false : {
            delay: 5000,
            pauseOnMouseEnter: true,
        },
        keyboard: {
            enabled: true,
        },
        a11y: {
            enabled: true,
            prevSlideMessage: 'Vorherige Bewertung',
            nextSlideMessage: 'Nächste Bewertung',
            firstSlideMessage: 'Dies ist die erste Bewertung',
            lastSlideMessage: 'Dies ist die letzte Bewertung',
            paginationBulletMessage: 'Gehe zu Bewertung {{index}}',
        },
    });

    // ── Offcanvas drawer: focus management & inert sync ────────────────────
    const drawer = document.getElementById('drawer-mainnavigation');
    const drawerTrigger = document.querySelector<HTMLElement>('[data-drawer-show="drawer-mainnavigation"]');

    if (drawer) {
        const FOCUSABLE = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';

        const isDrawerOpen = () => !drawer.classList.contains('-translate-x-full');

        const getFocusableChildren = () => Array.from(drawer.querySelectorAll<HTMLElement>(FOCUSABLE));

        const openDrawer = () => {
            drawer.removeAttribute('inert');
            // Focus the close button (first focusable = top of drawer)
            const closeBtn = drawer.querySelector<HTMLElement>('[data-drawer-hide]');
            closeBtn?.focus();
        };

        const closeDrawer = () => {
            drawer.setAttribute('inert', '');
            // Return focus to the hamburger trigger
            drawerTrigger?.focus();
        };

        // Watch Flowbite's class toggle (-translate-x-full added = closed)
        const drawerObserver = new MutationObserver(() => {
            if (isDrawerOpen()) {
                openDrawer();
            } else {
                closeDrawer();
            }
        });
        drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['class', 'aria-hidden'] });

        // Focus trap: keep Tab/Shift+Tab cycling inside the open drawer
        drawer.addEventListener('keydown', (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
                // Let Flowbite close the drawer; our observer will return focus
                return;
            }

            if (e.key !== 'Tab') return;

            const focusable = getFocusableChildren();
            if (focusable.length === 0) return;

            const first = focusable[0];
            const last = focusable[focusable.length - 1];

            if (e.shiftKey) {
                // Shift+Tab from first element → wrap to last
                if (document.activeElement === first) {
                    e.preventDefault();
                    last.focus();
                }
            } else {
                // Tab from last element → wrap to first
                if (document.activeElement === last) {
                    e.preventDefault();
                    first.focus();
                }
            }
        });

        // Also handle close button click explicitly for return focus
        const closeBtn = drawer.querySelector<HTMLElement>('[data-drawer-hide]');
        closeBtn?.addEventListener('click', () => {
            // Focus returns after Flowbite animates — small delay for the transition
            setTimeout(() => drawerTrigger?.focus(), 50);
        });
    }

    // ── Desktop navigation keyboard accessibility ──────────────────────────
    const navMenu = document.getElementById('main__menu');
    if (navMenu) {
        // Sync aria-expanded with :focus-within (CSS already opens the submenu)
        const parentLinks = navMenu.querySelectorAll<HTMLAnchorElement>('a[aria-haspopup="true"]');

        parentLinks.forEach((link) => {
            const submenuId = link.getAttribute('aria-controls');
            const submenu = submenuId ? document.getElementById(submenuId) : null;

            // Keep aria-expanded in sync when focus enters/leaves the parent <li>
            const li = link.closest('li');
            if (li && submenu) {
                li.addEventListener('focusin', () => {
                    link.setAttribute('aria-expanded', 'true');
                });
                li.addEventListener('focusout', (e) => {
                    // only close when focus truly leaves the entire <li> subtree
                    if (!li.contains((e as FocusEvent).relatedTarget as Node)) {
                        link.setAttribute('aria-expanded', 'false');
                    }
                });
            }

            // Enter / Space on a parent link opens submenu and focuses first item
            // instead of navigating – press Enter a second time to follow the link
            link.addEventListener('keydown', (e: KeyboardEvent) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    const expanded = link.getAttribute('aria-expanded') === 'true';
                    if (!expanded && submenu) {
                        e.preventDefault();
                        link.setAttribute('aria-expanded', 'true');
                        const firstFocusable = submenu.querySelector<HTMLElement>('a');
                        firstFocusable?.focus();
                    }
                    // if already expanded, let Enter follow the link naturally
                }
                if (e.key === 'Escape') {
                    link.setAttribute('aria-expanded', 'false');
                    link.focus();
                }
            });
        });

        // Close open submenus with Escape from anywhere inside them
        navMenu.addEventListener('keydown', (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
                const active = navMenu.querySelector<HTMLAnchorElement>('a[aria-expanded="true"]');
                if (active) {
                    active.setAttribute('aria-expanded', 'false');
                    active.focus();
                }
            }
        });
    }

    // FAQ Accordion with animated height (max-height via scrollHeight)
    const openFaqPanel = (button: HTMLButtonElement, target: HTMLElement) => {
        button.setAttribute('aria-expanded', 'true');
        button.querySelector('svg')?.classList.remove('rotate-180');
        target.style.maxHeight = target.scrollHeight + 'px';

        // Once open, release the explicit height so the panel reflows freely on resize
        const onEnd = () => {
            target.style.maxHeight = 'none';
            target.removeEventListener('transitionend', onEnd);
        };
        target.addEventListener('transitionend', onEnd);
    };

    const closeFaqPanel = (button: HTMLButtonElement, target: HTMLElement) => {
        button.setAttribute('aria-expanded', 'false');
        button.querySelector('svg')?.classList.add('rotate-180');

        // Pin to current rendered height first so the browser has a concrete start value
        target.style.maxHeight = target.scrollHeight + 'px';
        void target.offsetHeight; // force reflow
        target.style.maxHeight = '0';
    };

    document.querySelectorAll<HTMLElement>('[data-faq-accordion]').forEach(accordion => {
        accordion.querySelectorAll<HTMLButtonElement>('[data-faq-toggle]').forEach(button => {
            button.addEventListener('click', () => {
                const targetId = button.getAttribute('data-faq-target');
                const target = targetId ? document.getElementById(targetId) as HTMLElement : null;
                const isExpanded = button.getAttribute('aria-expanded') === 'true';

                // Collapse all other open panels
                accordion.querySelectorAll<HTMLButtonElement>('[data-faq-toggle]').forEach(otherBtn => {
                    if (otherBtn === button) return;
                    const otherId = otherBtn.getAttribute('data-faq-target');
                    const otherTarget = otherId ? document.getElementById(otherId) as HTMLElement : null;
                    if (otherBtn.getAttribute('aria-expanded') === 'true' && otherTarget) {
                        closeFaqPanel(otherBtn, otherTarget);
                    }
                });

                // Toggle current panel
                if (target) {
                    if (isExpanded) {
                        closeFaqPanel(button, target);
                    } else {
                        openFaqPanel(button, target);
                    }
                }
            });
        });
    });

    // ── Image grid lightbox (tt_content "image" layout = 101) ──────────────
    // Lightweight gallery overlay that mirrors the room-gallery UX without
    // pulling Swiper into the plain image CE. Keyboard: ← → navigate, Esc
    // closes. Focus returns to the thumb that opened the overlay.
    document.querySelectorAll<HTMLElement>('[data-image-grid-gallery]').forEach(gallery => {
        const lightbox = gallery.querySelector<HTMLElement>('[data-gallery-lightbox]');
        const slides = Array.from(gallery.querySelectorAll<HTMLElement>('[data-gallery-slide]'));
        const counter = gallery.querySelector<HTMLElement>('[data-gallery-counter]');
        const prevBtn = gallery.querySelector<HTMLButtonElement>('[data-gallery-prev]');
        const nextBtn = gallery.querySelector<HTMLButtonElement>('[data-gallery-next]');
        const closeBtn = gallery.querySelector<HTMLButtonElement>('[data-gallery-close]');
        const thumbs = Array.from(gallery.querySelectorAll<HTMLButtonElement>('[data-gallery-open]'));

        if (!lightbox || slides.length === 0) {
            return;
        }

        // Portal the lightbox to <body> so it escapes any ancestor stacking
        // contexts (relative/transform/z-index frames on the page).
        if (lightbox.parentElement !== document.body) {
            document.body.appendChild(lightbox);
        }

        let currentIndex = 0;
        let openerButton: HTMLButtonElement | null = null;

        const setActive = (index: number): void => {
            currentIndex = (index + slides.length) % slides.length;
            slides.forEach((slide, i) => {
                const isActive = i === currentIndex;
                slide.setAttribute('data-active', isActive ? 'true' : 'false');
                slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
            });
            if (counter) {
                counter.textContent = `${currentIndex + 1} / ${slides.length}`;
            }
        };

        const openLightbox = (index: number, opener: HTMLButtonElement): void => {
            openerButton = opener;
            lightbox.hidden = false;
            document.body.classList.add('overflow-hidden');
            setActive(index);
            // Give the dialog focus so Esc / arrow keys are captured reliably
            requestAnimationFrame(() => closeBtn?.focus());
        };

        const closeLightbox = (): void => {
            lightbox.hidden = true;
            document.body.classList.remove('overflow-hidden');
            openerButton?.focus();
            openerButton = null;
        };

        thumbs.forEach(thumb => {
            thumb.addEventListener('click', () => {
                const index = Number.parseInt(thumb.dataset.galleryOpen ?? '0', 10);
                openLightbox(Number.isNaN(index) ? 0 : index, thumb);
            });
        });

        prevBtn?.addEventListener('click', () => setActive(currentIndex - 1));
        nextBtn?.addEventListener('click', () => setActive(currentIndex + 1));
        closeBtn?.addEventListener('click', closeLightbox);

        // Close on backdrop click (but not when clicking the image / controls)
        lightbox.addEventListener('click', (e) => {
            if (e.target === lightbox) {
                closeLightbox();
            }
        });

        document.addEventListener('keydown', (e: KeyboardEvent) => {
            if (lightbox.hidden) return;
            switch (e.key) {
                case 'Escape':
                    e.preventDefault();
                    closeLightbox();
                    break;
                case 'ArrowLeft':
                    e.preventDefault();
                    setActive(currentIndex - 1);
                    break;
                case 'ArrowRight':
                    e.preventDefault();
                    setActive(currentIndex + 1);
                    break;
            }
        });
    });

    // Video Play Functionality
    const videoContainers = document.querySelectorAll('[data-video-container]');
    videoContainers.forEach(container => {
        const playBtn = container.querySelector('[data-video-play-btn]');
        const overlay = container.querySelector('[data-video-overlay]');
        const videoElement = container.querySelector('video, iframe');

        if (playBtn && overlay && videoElement) {
            playBtn.addEventListener('click', (e) => {
                e.preventDefault();

                // Remove overlay with fade out animation
                overlay.classList.add('opacity-0', 'transition-opacity', 'duration-300');
                setTimeout(() => {
                    overlay.remove();
                }, 300);

                // Play video
                if (videoElement.tagName === 'VIDEO') {
                    (videoElement as HTMLVideoElement).play();
                } else if (videoElement.tagName === 'IFRAME') {
                    // For YouTube/Vimeo iframes, add autoplay parameter
                    const iframe = videoElement as HTMLIFrameElement;
                    const src = iframe.src;

                    if (src.includes('youtube.com') || src.includes('youtu.be')) {
                        iframe.src = src + (src.includes('?') ? '&' : '?') + 'autoplay=1';
                    } else if (src.includes('vimeo.com')) {
                        iframe.src = src + (src.includes('?') ? '&' : '?') + 'autoplay=1';
                    }
                }
            });
        }
    });
});
